import { Link, Outlet, useNavigate } from "react-router-dom";
import "../styles/AdminContact.css";

const AdminLayout = () => {

  const navigate = useNavigate();

  const logout = () => {
    localStorage.removeItem("token");
    navigate("/login");
  };

  return (
    <div className="admin-layout">

      {/* SIDEBAR */}
      <div className="admin-sidebar">

        <div className="admin-logo">
          Admin Panel
        </div>

        <div className="admin-menu">

          <Link to="/admin/contact" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>Contact Messages</Link>
          <Link to="/admin/admissions" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>Admission Enquiries</Link>
          <Link to="/admin/students" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>Online Registrations</Link>
          <Link to="/admin/onlineadmissioncontrol" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>Online Registration Settings</Link>
          <Link to="/admin/printforms" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>Online Admission Forms</Link>
          <Link to="/admin/sliders" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>Slider Manager</Link>
          <Link to="/admin/admingallery" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>Gallery Manager</Link>
          <Link to="/admin/adminactivity" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>Activity Manager</Link>
          <Link to="/admin/adminalumni" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>Alumni Manager</Link>
          <Link to="/admin/admincalender" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>Calendar Manager</Link>
          <Link to="/admin/adminstaffs" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>Staffs Manager</Link>
          <Link to="/admin/adminnews" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>News Manager</Link>
          <Link to="/admin/adminchooseus" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>Why To Be Northanian</Link>
          <Link to="/admin/facility" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>Facility Manager</Link>
          <Link to="/admin/videofilm" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>Home Video Manager</Link>
          <Link to="/admin/typedownfiles" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>Download Manager</Link>
          <Link to="/admin/feesrules" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>Fees Manager</Link>
          <Link to="/admin/listholiday" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>Holidays Manager</Link>
          


          <button onClick={logout} className="logout-btn">
            Logout
          </button>

        </div>

      </div>

      {/* CONTENT */}
      <div className="admin-content">
        <Outlet />
      </div>

    </div>
  );
};

export default AdminLayout;